import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Box, IconButton, Tooltip } from '@mui/material';
import ClearIcon from '../../../assets/icons/clear-icon';
import DownloadIcon from '../../../assets/icons/download-icon';
import ReloadIcon from '../../../assets/icons/reload-icon';
import {
  clearAllPreFlashFilter,
  downloadErrorLog,
  postFlashLogs,
  preFlashLogs,
  removeAllDevices,
} from '../../../store/bulk-device-flash/actions';
import ColumnSortVisibility from '../../virtualized-table/components/column-sort-visibility';
import { AppState } from '../../../store';
import { TabContent } from '../../../pages/bulk-device-management/types';
import { FlashTabStrings } from '../../../store/bulk-device-flash/types';
import theme from '../../../globals/theme';
import ClearFilterIcon from '../../../assets/icons/clear-filter-icon';

const LoadedContentButtons = ({ tabInstance }: { tabInstance: TabContent }) => {
  const errorLogDownloadIds = useSelector(
    (state: AppState) => state.bulkFlash.errorFileDownloadIds,
  );

  const hasFilters =
    Object.keys(useSelector((state: AppState) => state.bulkFlash.preFlashFilters)).length === 0;
  const logTab = useSelector((state: AppState) => state.bulkFlash.logTab);

  const errorLogId =
    (logTab === FlashTabStrings.preFlash && errorLogDownloadIds.preFlash) ||
    (logTab === FlashTabStrings.postFlash && errorLogDownloadIds.postFlash);

  const dispatch = useDispatch();

  const handleReloadData = () => {
    if (logTab === FlashTabStrings.postFlash) dispatch(postFlashLogs({}));
    if (logTab === FlashTabStrings.preFlash) dispatch(preFlashLogs({}));
  };

  const handleClearRecords = () => dispatch(removeAllDevices());

  const noData = !tabInstance.data;
  const enterDelay = 700;

  return (
    <Box display="flex">
      <Box>
        <span>
          <Tooltip title="Refresh Table" enterDelay={enterDelay}>
            <IconButton
              disabled={noData}
              onClick={handleReloadData}
              id="reloadButton"
              size="large">
              <ReloadIcon
                stroke={`${noData ? theme.palette.grey[400] : theme.palette.grey[600]}`}
              />
            </IconButton>
          </Tooltip>
        </span>
      </Box>
      <Box>
        <Tooltip title="Clear Records" enterDelay={enterDelay}>
          <span>
            <IconButton
              disabled={noData}
              onClick={handleClearRecords}
              id="exportButton"
              size="large">
              <ClearIcon stroke={`${noData ? theme.palette.grey[400] : theme.palette.grey[600]}`} />
            </IconButton>
          </span>
        </Tooltip>
      </Box>
      <Box>
        <Tooltip title="Download Error Log" enterDelay={enterDelay}>
          <span>
            <IconButton
              disabled={!errorLogId}
              onClick={() => errorLogId && dispatch(downloadErrorLog(errorLogId))}
              id="exportButton"
              size="large">
              <DownloadIcon
                fill={`${errorLogId ? theme.palette.error.dark : theme.palette.grey[400]}`}
              />
            </IconButton>
          </span>
        </Tooltip>
      </Box>
      <Box>
        {logTab === FlashTabStrings.preFlash && (
          <Tooltip title="Remove Filters" enterDelay={enterDelay}>
            <span>
              <IconButton
                disabled={hasFilters}
                onClick={() => dispatch(clearAllPreFlashFilter())}
                id="exportButton"
                size="large">
                <ClearFilterIcon
                  stroke={`${hasFilters ? theme.palette.grey[400] : theme.palette.grey[600]}`}
                />
              </IconButton>
            </span>
          </Tooltip>
        )}
      </Box>
      <Box>
        <ColumnSortVisibility {...tabInstance} />
      </Box>
    </Box>
  );
};

export default LoadedContentButtons;
